import React, { PureComponent } from 'react'
import cx from 'classnames'

import Icons from 'components/ui/Icons/Icons'

import s from './CheckBoxView.scss'


class CheckBoxView extends PureComponent {

  render() {
    const { className, isChecked, disabled, onClick } = this.props

    return (
      <div
        className={cx(s.checkbox, className, {
          [s.checked]: isChecked,
          [s.disabled]: disabled,
        })}
        onClick={onClick}
      >
        {
          Boolean(isChecked) && (
            <Icons
              className={s.icon}
              name="checkmark"
              color="white"
            />
          )
        }
      </div>
    )
  }
}


export default CheckBoxView
